import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { ItemCustody, ItemCustodyFilters } from '../interfaces/item-custody.interface';
import { AuthService } from './auth.service';

export interface ItemCustodyPage {
    content: ItemCustody[];
    totalElements: number;
    number: number;
    size: number;
}

export const ItemCustodyService = {
    /** Items out with people (STOCK_VIEW; limited to the stores the caller is in charge of). */
    list: async (filters: ItemCustodyFilters, page = 0, size = 10): Promise<ItemCustodyPage> => {
        const institutionId = AuthService.getSelectedInstitution();
        const params: Record<string, string | number> = { page, size };
        (Object.keys(filters) as (keyof ItemCustodyFilters)[]).forEach((k) => {
            const v = filters[k];
            if (v) params[k] = v;
        });
        const r = await axios.get(ENDPOINTS.ITEM_CUSTODY.LIST_BY_INSTITUTION(institutionId!), { params });
        return r.data;
    },

    /** Bring qty back into the store it came from, at the cost it left at (STOCK_ISSUE). */
    returnToStore: async (id: string, qty: number, remarks?: string, serials?: string[]): Promise<ItemCustody> =>
        (await axios.post(ENDPOINTS.ITEM_CUSTODY.RETURN(id),
            { qty, remarks: remarks || null, ...(serials && serials.length ? { serials } : {}) })).data,

    /** Close qty as lost or damaged; no stock or ledger movement (STOCK_ISSUE). */
    writeOff: async (id: string, qty: number, reason: string, serials?: string[]): Promise<ItemCustody> =>
        (await axios.post(ENDPOINTS.ITEM_CUSTODY.WRITE_OFF(id),
            { qty, reason, ...(serials && serials.length ? { serials } : {}) })).data,
};
